import * as actions from './actions'
import { Record } from '../transit'

const State = Record({
  location: '',
  path: '',
  downloading: false,
  zipLocation: '',
  zipPath: '',
  zipDownloading: false,
}, 'downloads')

const downloadsReducer = (state = new State(), action) => {
  if (action.type === 'DOWNLOAD_CERTIFICATES_ZIP_SUCCESS') {
    const location = action.payload.data
    return state.set('zipLocation', location).set('zipDownloading', true).set('zipPath', '')
  }
  if (action.type.startsWith('DOWNLOAD_') && action.type.endsWith('_SUCCESS')) {
    const location = action.payload.data
    return state.set('location', location).set('downloading', true).set('path', '')
  }
  switch (action.type) {
    case actions.CHECK_FILE_SUCCESS: {
      const path = action.payload.data.path
      if (path) return state.set('path', path).set('downloading', false)
      return state
    }
    case actions.CLEAR_DOWNLOAD: {
      return state.set('location', '').set('downloading', false).set('path', '')
    }
    case actions.CHECK_ZIP_FILE_SUCCESS: {
      const path = action.payload.data.path
      if (path) return state.set('zipPath', path).set('zipDownloading', false)
      return state
    }
    case actions.CLEAR_ZIP_DOWNLOAD: {
      return state.set('zipLocation', '').set('zipDownloading', false).set('zipPath', '')
    }
    default:
      return state
  }
}

export default downloadsReducer



// WEBPACK FOOTER //
// ./src/common/downloads/reducer.js